// src/components/layout/layout.js
import React from "react";
import SideNavBar from "../sideNavBar/sideNavBar";
import TopNavBar from "../topNavBar/topNavBar";
import Notification from "../customNotification/Notification";
import "../../index.css";
import "./layout.css";

function Layout({ navTitle, pageTitle, children, notificationProps }) {
  // Normalize to array — works whether a page passes a single object or an array
  const notifications = !notificationProps ? [] : Array.isArray(notificationProps) ? notificationProps : [notificationProps];

  return (
    <div className="page-wrapper">
      {/* Sidebar */}
      <div className="grid-sidebar">
        <SideNavBar />
      </div>

      {/* Top navigation */}
      <div className="grid-topnav">{navTitle && <TopNavBar title={navTitle} />}</div>

      {/* Main content */}
      <div className="grid-main-content">
        {pageTitle && (
          <div className="page-top-section">
            <h2 className="page-title">{pageTitle}</h2>
          </div>
        )}
        {children}
      </div>

      {/* Notifications */}
      <div className="notification-container">
        {notifications.map((notif, index) => (
          <Notification key={index} {...notif} />
        ))}
      </div>
    </div>
  );
}

export default Layout;
